import { API, graphqlOperation } from "aws-amplify";
import uuid from "uuid";

import * as mutations from '../../graphql/mutations';

import {
    UPDATE_CURRENT_APPLICATION_STATE
} from "../constants/action-types";

export async function saveSupplyAppSync(items, grantApplication, user, funcs) {

    items.forEach((payload) => {
        if (!payload.id) {
            // This means that you are creating a new supply
            let supplyFilter = {
                input: {
                    grantApplicationSupplyId: grantApplication.id,
                    name: payload.name,
                    federal: payload.federal || null,
                    county: payload.county || null,
                    countyInKind: payload.countyInKind || null,
                    deleted: payload.deleted,
                    updatedBy: user.username
                }
            }

            funcs.push(API.graphql(graphqlOperation(mutations.createSupply, supplyFilter)));
        } else {


            let same = false;
            for (let index = 0; index < grantApplication.supply.items.length; index++) {
                const item = grantApplication.supply.items[index];
                if ((item.id == payload.id) && (JSON.stringify(item) == JSON.stringify(payload))) {
                    same = true;
                    break;
                }
            }

            if(!same) {
                let supplyFilter = {
                    input: {
                        grantApplicationSupplyId: grantApplication.id,
                        id: payload.id,
                        name: payload.name,
                        federal: payload.federal || null,
                        county: payload.county || null,
                        countyInKind: payload.countyInKind || null,
                        deleted: payload.deleted,
                        updatedBy: user.username
                    }
                }
    
                funcs.push(API.graphql(graphqlOperation(mutations.updateSupply, supplyFilter)));
            }

        }
    })
}

export function saveSupply(payload) {
    return async function (dispatch, getState) {


        const { grantApplication, currentApplicationState } = getState().rootReducer;
        if (!currentApplicationState.supply.items) {
            currentApplicationState.supply.items = [];
        }

        if (!payload.id && !payload.tempId) {
            payload.tempId = uuid.v4();
        }


        let arr = currentApplicationState.supply.items, found = false;
        for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            if (item.tempId) {
                if (item.tempId == payload.tempId) {
                    currentApplicationState.supply.items[i] = payload;
                    found = true;
                    break;
                }
            } else {
                if (item.id == payload.id) {
                    currentApplicationState.supply.items[i] = payload;
                    found = true;
                    break;
                }
            }

        }

        if (!found) {
            currentApplicationState.supply.items.push(payload)
        }

        dispatch({ type: UPDATE_CURRENT_APPLICATION_STATE, payload: JSON.parse(JSON.stringify(currentApplicationState)) });

    }
}
